import _extends from "@babel/runtime/helpers/esm/extends";
import { fieldsIBaseModelWithUser } from './base';
import { EModel } from './model';
export let ECustomWebStyleScope;
(function (ECustomWebStyleScope) {
  ECustomWebStyleScope["Cobranding"] = "cobranding";
  ECustomWebStyleScope["PatientApp"] = "patientApp";
  ECustomWebStyleScope["PatientAppV2"] = "patientAppV2";
  ECustomWebStyleScope["PatientFormsV3"] = "patientFormsV3";
})(ECustomWebStyleScope || (ECustomWebStyleScope = {}));
export const fieldsCustomWebStyle = _extends({}, fieldsIBaseModelWithUser, {
  description: {
    type: 'Text'
  },
  published: {
    type: 'Boolean'
  },
  publishedAt: {
    type: 'Date'
  },
  publishedBy: {
    type: 'ID',
    ref: EModel.User
  },
  scope: {
    type: 'Option',
    values: ECustomWebStyleScope
  },
  styles: {
    type: 'Object'
  },
  uploads: {
    type: 'Object',
    array: true
  },
  url: {
    type: 'Text'
  }
});